module.exports = __webpack_public_path__ + "img/entrees.26df5c9d.png";